<span class="square {{ data?.type }} {{ data?.class }}" [matTooltip]="data?.key | translate" [matTooltipDisabled]="!showTooltip">{{
  data?.label | translate
}}</span>
<span *ngIf="showDescription">{{ data?.key | translate }}</span>
